<template>
  <PurchaseTable query-type="order"></PurchaseTable>
</template>

<script>
import PurchaseTable from '@/views/modules/erp/client/common/purchase/purchase-table.vue'

export default {
  mixins: [],
  components: { PurchaseTable },
  data () {
    return {}
  },
  methods: {}
}
</script>
